<template>
	<div style="background-color: #000; display: flex; flex-wrap: wrap; justify-content: space-between;">
		<!--
		<div class="std-pad" style="width: 100%; background-color: #fff; margin-top: 100px; padding-top: 100px; padding-bottom: 100px; text-align: center;">
	
			<h3 class="black center">Why Menacing?</h3>
			<h1 class="black center massive">RESULTS.</h1>
			<h4 class="black center">We have developed a battle tested, proven formula that works across<br>A variety of industries - Resulting in millions generated for ourselves and our clients</h4>

			<button class="blue-button">Book your Call Today</button>
		</div>
		-->
		<div class="std-pad" style="padding-top: 220px; padding-bottom: 60px;">
			<div class="col col-lg-6">
				<h1 class="thin big" style="padding-bottom: 40px;">ABOUT US</h1>

				<p class="small-text">At Menacing Media, we are a highly driven, creative and experienced team with 10+ years of professional experience in web technology. We like to create bespoke, fit for purpose websites that generate you more leads.</p>
				
				<p class="small-text">Based in Ipswich and working with local and international clients, large and small. We help our clients discover what makes them unqiue, and help them channel that into a unique brand. In this day and age, regardless of your business, you need to stand out online to remain competitive.</p>

				<p class="small-text">We pride ourselves on creating world class experiences, and tangible results you can measure in real time.</p>

				<p class="small-text">We keep our process simple, transparent, and focused on what you specifically need. We avoid using complicated jargon and will always opt for simplicity, usability and scalability.</p>
			</div>
			<div class="col col-lg-6 std-pad" style="text-align: right; padding-top: 100px;">
				<!--
				<svg id="squiggle" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1567.53 606.6">
					<text class="cls-1" transform="translate(0.01 359.54)">A</text>
					<text class="cls-1" transform="translate(1443.22 357)">B</text>
					<path
						class="cls-2"
						d="M289,504a859.43,859.43,0,0,0,168,2c167.08-14.48,320-77.66,315.5-100.5-5-25.36-201,14.71-210-19-9.66-36.11,195.34-156.65,263-102,77.51,62.61-80.06,310.82-16,358,70.85,52.19,375.52-169,343-255-34.62-91.5-455.08-40-463,27-9.83,83,614.66,189,604,258-8,51.56-366.56,57.1-373,16-5.74-36.59,267.43-111.19,560-181"
						transform="translate(-105.95 -225.66)"
					>
					</path>
				</svg>
				-->
			</div>
		</div>

		<div class="col col-md-12 std-pad center" style="padding-top: 20px; padding-bottom: 100px;">
			<router-link to="/contact" class="hvr-grow">
				<button class="blue-button">Get in Touch</button>
			</router-link>
		</div>

		<div style="padding-top: 40px; padding-bottom: 60px;">

			<div class="col col-md-4 std-pad">
				<h2 class="thin" style="padding-bottom: 20px">#1: Our Mission</h2>
				<p>Forget the one size fits all stuff. Our incredible team's capabilities are focused around user experience, brand uniqueness, data driven organic and paid lead generation and intelligent sales optimization - this is where we thrive.</p>
			</div>

			<div class="col col-md-8" style="height: 100px;"></div>

			<div class="col col-md-8 std-pad" style="height: 100px;"></div>

			<div class="col col-md-4 std-pad">
				<h2 class="thin" style="padding-bottom: 20px">#2: Our Values</h2>
				<p>Our values are simple. We focus on user experience, going the extra mile, and being passionate about the work we do.</p>
			</div>

			<div class="col col-md-4 std-pad">
				<h2 class="thin" style="padding-bottom: 20px">#3: Our Commitment</h2>
				<p>To stick to our word, strive for excellence, be honest when it's challenging, and never give up on the mission.</p>
			</div>

		</div>


		<!-- pictures of cows and people shaking hands -->
		<!--
		<div style="background-color: #fff; padding-top: 80px; padding-bottom: 80px;">

			<div>
				<div class="col col-lg-6 std-pad">
					<h3 class="black">Reliable, consistent,<br> client focused <br>Support.</h3>
					<p class="black small-text">Clients jump onboard for our accessibility, responsiveness and results. We go above and beyond to ensure you always get a response, receive regular reports and never feel ignored or put to the side.</p>
				</div>
				<div class="col col-lg-6 std-pad slow-scroll" style="text-align: center;">
					<img class="offset-img" src="@/assets/people_shaking_hands_mist.png" style="transform: translateY(0); width: 240px; position: absolute;" />
					<img id="people-shaking" src="@/assets/people_shaking_hands.png" style="width: 240px;" />
				</div>
			</div>

			<div style="padding-top: 140px;">
				<div class="col col-lg-6 std-pad slow-scroll" style="text-align: center;">
					<img id="purple-cow" class="offset-img" src="@/assets/cow_purple.png" style="transform: translateY(0); width: 240px; position: absolute;" />
					<img src="@/assets/cow_outline.png" style="width: 240px;" />
				</div>
				<div class="col col-lg-6 std-pad">
					<h3 class="black" style="text-align: right;">You love your<br> business, Now Let's<br>stand out from<br>the crowd.</h3>
					<p class="black small-text" style="text-align: right;">We are numbers focused, so we will get to work with you or your marketing team to ensure we are hitting the ground fast, hitting your KPI's. Smashing financial targets, and understanding the steps we took to acheive it, with clear data.</p>
				</div>
			</div>

			<div style="padding-top: 140px;">
				<div class="col col-lg-6 std-pad">
					<h3 class="black">Measurable results.</h3>
					<p class="black small-text">Clients jump onboard for our accessibility, responsiveness and results. We go above and beyond to ensure you always get a response, receive regular reports and never feel ignored or put to the side.</p>
				</div>
				<div class="col col-lg-6 std-pad slow-scroll" style="text-align: center;">
					<img class="offset-img" src="@/assets/axis.png" style="transform: translateY(0); width: 240px; position: absolute;" />
					<img src="@/assets/line_go_up.png" style="width: 240px;" />
				</div>
			</div>

			<div class="col col-md-12 std-pad center" style="padding-top: 20px; padding-bottom: 100px;">
				<button class="blue-button">Book Your Call Today</button>
			</div>

			<div class="col col-md-12 std-pad center">
				<h1 class="black">Customer Happiness</h1>
				<h3 class="black thin" style="text-align: right">Our goal is word of mouth marketing, and we<br>can only do this by over delivering for our clients.<br>Customer happiness is what we measure first at menacing.</h3>
			</div>
		</div>
		-->

		<!-- Meet the team -->

		<div class="std-pad" style="padding-bottom: 140px; margin: auto;">
			<h1 class="center thin" style="padding-bottom: 80px; padding-top: 60px;">Meet the team</h1>

	      <!-- tomasz -->
	        <div class="staff col col-md-4 center">
	          <img data-aos="fade-down center" src="@/assets/about/tomasz.png" alt="Tomasz Tchorzewski" style="border-radius: 200px;">
	          <h2 class="thin center" data-aos="fade-down center">Tomasz Tchorzewski</h2>
	          <h3 class="thin center regular" data-aos="fade-down center">Design</h3>
	        </div>

	      <!-- kasper -->
	        <div class="staff col col-md-4 center">
	          <img data-aos="fade-down center" src="@/assets/about/kasper.png" alt="Kasper Wilkosz" style="border-radius: 200px;">
	          <h2 class="thin center" data-aos="fade-down center">Kasper Wilkosz</h2>
	          <h3 class="thin center regular" data-aos="fade-down center">Technical</h3>
	        </div>

	      <!-- tom -->
		    <div class="staff col col-md-4 center">
		      <img data-aos="fade-down center" src="@/assets/about/tom.png" alt="Thomas Wade" style="border-radius: 200px;">
		      <h2 class="thin center" data-aos="fade-down center">Thomas Wade</h2>
		      <h3 class="thin center regular" data-aos="fade-down center">Marketing Consultant</h3>
		    </div>

			<!-- lucas -->
			<div class="staff col col-md-4 center">
				<div style="margin: auto; border-radius: 1000px; width: 200px; height: 200px; background-color: #111; margin-bottom: 40px;">
					<h2 class="user-icon"><i class="fas fa-user"></i></h2>
				</div>
				<h2 class="thin center" data-aos="fade-down center">Lucas CR</h2>
				<h3 data-aos="fade-down center" class="thin center regular">3D &amp; Animation Artist</h3>
			</div>

			<!-- mariella -->
			<div class="staff col col-md-4 center">
				<div style="margin: auto; border-radius: 1000px; width: 200px; height: 200px; background-color: #111; margin-bottom: 40px;">
					<h2 class="user-icon" ><i class="fas fa-user"></i></h2>
				</div>
				<h2 class="thin center" data-aos="fade-down center">Mariella P</h2>
				<h3 data-aos="fade-down center" class="thin center regular">Support</h3>
			</div>

			<!-- graham -->
			<div class="staff col col-md-4 center">
				<div style="margin: auto; border-radius: 1000px; width: 200px; height: 200px; background-color: #111; margin-bottom: 40px;">
					<h2 class="user-icon" ><i class="fas fa-user"></i></h2>
				</div>
				<h2 class="thin center" data-aos="fade-down center">Graham MacMurdie</h2>
				<h3 data-aos="fade-down center" class="thin center regular">Sales</h3>
			</div>

		</div>


		<Sparkle />
	</div>
</template>

<script>

	import Sparkle from '@/components/Sparkle.vue'

	export default {
	  name: 'About',
	  components: {
		Sparkle
	  },
	  mounted() {

	  }
	}
</script>

<style lang="scss">

	.staff {
		margin-bottom: 60px;
		h2 {
			margin-bottom: 20px;
			margin-top: 40px;
		}
	}

	.user-icon {
		font-size: 100px;
		padding-top: 40px;
		padding-left: 56px;
	}

	.slow-scroll:hover img {
		opacity: 1 !important;
	}


	/* SVG */

	#squiggle polyline,
	#squiggle line,
	#squiggle path {
		stroke-linecap: round;
		stroke-linejoin: round;
		transition: 2s;
		transition-property: d;
		transition-duration: 4s;
	}

	.cls-1 {
		fill:#fff;
		font-size: 420px;
		font-family: HateYourWriting, Hate Your Writing, Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif;
	}
	.cls-2 {
		fill:none;
		stroke:#fff;
		stroke-miterlimit:10;
		stroke-width:16px;
	}
	
	#squiggle:hover path {
		d: path("M289,504c72.15,10,128.85,6.93,168,2,29-3.65,45.08-7.89,115.5-17.5,42-5.73,63.71-8.66,94-11a1083,1083,0,0,1,114-3c67,2.09,68.18,9.48,141,14,64,4,57.89-2.07,138,2,44.79,2.27,83.4,4.36,134,13,26.23,4.48,34.93,7.18,67,12,31.47,4.73,62.67,9.43,95,10,29.48.52,72.57-2.16,125-18");
	}
	

</style>